import { useEffect } from 'react';

import {
  getInlineImageUploadProgress,
  subscribeInlineImageUploadProgress,
} from '../utils/richContent/inlineAttachmentName';

import type { FileUploadProgress } from '../services/fileUploadService';

/** Mirror inline-image upload state into the request footer progress bar. */
export function useInlineImageUploadFooterProgress(
  setUploadProgress: (progress: FileUploadProgress | null) => void,
): void {
  useEffect(() => {
    const sync = (): void => {
      const inline = getInlineImageUploadProgress();
      if (!inline) {
        setUploadProgress(null);
        return;
      }
      setUploadProgress({
        section: 'inline-image',
        fileName: inline.fileName,
        progress: inline.progress,
        status: inline.status,
      });
    };

    sync();
    return subscribeInlineImageUploadProgress(sync);
  }, [setUploadProgress]);
}
